import { useParams } from "react-router-dom";
import { ChatDetail } from "@/components/features/ChatDetail";

export function ChatDetailPage() {
  const { chatId } = useParams<{ chatId: string }>();
  if (!chatId) return null;
  return <ChatDetail chatId={chatId} />;
}
